import { Menu } from "../components/Menu";
import ArchiveSpace from "./ArchiveSpace";
import ExportJSON from "./ExportJSON";
import ExportText from "./ExportText";
import ExportWebpage from "./ExportWebpage";

export default function Overflow() {
  return (
    <>
      <Menu icon="Menu" ariaLabel="Menu">
        <ExportWebpage />
        <ExportText />
        <ExportJSON />
        <ArchiveSpace />
      </Menu>
    </>
  );
}
